import React from "react";
import { node, string } from "prop-types";
import Link from "@insightfulscience/atomic-react/Link";
import NextLink from "@insightfulscience/smart-react/NextLink";
import getContentProps from "../utils/getContentProps";

const PostEntryLink = ({ contentId, slug = "", children, ...props }) => {
	const contentProps = getContentProps(contentId);
	const isCustom = contentProps === false;

	if (isCustom) {
		return (
			<Link href={slug} target="_blank">
				{children}
			</Link>
		);
	}
	const isExternal = contentProps && contentProps.type === "external";
	const Tag = ({ ...tagProps }) =>
		isExternal ? <Link {...tagProps} /> : <NextLink {...tagProps} />;
	const href = isExternal ? slug : `${contentProps.alias}/${slug}`;
	return (
		<Tag href={href} {...props} target={isExternal ? "_blank" : "_self"}>
			{children}
		</Tag>
	);
};

PostEntryLink.propTypes = {
	contentId: string.isRequired,
	slug: string,
	children: node.isRequired,
};

export default PostEntryLink;
